import React, { useState, useEffect } from 'react';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import Form from 'react-bootstrap/Form';
import { Popover } from 'antd';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import '../../../pages/admin/admin_assets/css/Profile.css';
import '../../../pages/admin/admin_assets/css/Setting.css';
import '../../../pages/admin/admin_assets/css/UserManagement.css';
import three_dots from '../../../pages/admin/admin_assets/img/three_dots.svg';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import config from '../../../config/config.js';

const SuspendPopUp = ({ show, onHide, onConfirm }) => (
  <Modal show={show} onHide={onHide} size="lg" backdrop="static" centered className='yes_cancel'>
    <Modal.Body>
      <div className="confirm-removal-modal">
        <div className="confirm-removal-content">
          <h4>Confirm User Suspension</h4>
          <p>Are you sure you want to suspend this user? They will be temporarily blocked from accessing their account, but their data will remain intact.</p>
        </div>
      </div>
    </Modal.Body>
    <Modal.Footer className='border-0'>
      <Button onClick={onConfirm}>Yes, Suspend User</Button>
      <Button onClick={onHide}>Cancel</Button>
    </Modal.Footer>
  </Modal>
);

const RemovePopUp = ({ show, onHide, onConfirm }) => (
  <Modal show={show} onHide={onHide} size="lg" backdrop="static" centered className='yes_cancel'>
    <Modal.Body>
      <div className="confirm-removal-modal">
        <div className="confirm-removal-content">
          <h4>Confirm User Removal</h4>
          <p>Are you sure you want to permanently remove this user? This action cannot be undone, and the user will lose all access to the platform.</p>
        </div>
      </div>
    </Modal.Body>
    <Modal.Footer className='border-0'>
      <Button onClick={onConfirm}>Yes, Remove User</Button>
      <Button onClick={onHide}>Cancel</Button>
    </Modal.Footer>
  </Modal>
);

const MyVerticallyCenteredModal = ({ show, onHide, onAddMember }) => {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [role, setRole] = useState('Admin'); // default to 'Admin'
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [emailError, setEmailError] = useState('');

  // Regex for basic email validation
  const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setEmailError('');

    // Check if all fields are filled
    if (!name || !email || !role) {
      toast.error('All fields are required!');
      setIsSubmitting(false);
      return;
    }

    // Validate email format
    if (!emailRegex.test(email)) {
      setEmailError('Please enter a valid email address');
      setIsSubmitting(false);
      return;
    }

    const password = 'h8U#zP@tQ7wLx2&1BzM9'; // Default password (in plain text)

    try {
      // Send the plain password to the backend
      await onAddMember({ name, email, role, password });
      setName('');
      setEmail('');
      setRole('Admin');
      setIsSubmitting(false);
      onHide(); // Close modal after submitting
      //toast.success('New member added successfully!');
    } catch (error) {
      setIsSubmitting(false);
      toast.error('Error adding new member');
    }
  };

  return (
    <Modal
      show={show}
      onHide={onHide}
      size="lg"
      backdrop="static"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      className='user_management_popup'
    >
      <Modal.Body>
        <h4>Add New Member</h4>
        <Form onSubmit={handleSubmit}>
          <Form.Group className="mb-3" controlId="name">
            <Form.Label>Name <sup><i className="bi bi-asterisk" style={{color:"#DE0A0C"}}></i></sup></Form.Label>
            <Form.Control
              type="text"
              placeholder="Enter name"
              value={name}
              onChange={(e) => setName(e.target.value)}
              required
            />
          </Form.Group>

          <Form.Group className="mb-3" controlId="email">
            <Form.Label>Email address <sup><i className="bi bi-asterisk" style={{color:"#DE0A0C"}}></i></sup></Form.Label>
            <Form.Control
              type="email"
              placeholder="Enter email address"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
            {emailError && <div className="text-danger">{emailError}</div>} {/* Display email error */}
          </Form.Group>

          <Form.Label>Role<sup><i className="bi bi-asterisk" style={{color:"#DE0A0C"}}></i></sup></Form.Label>
          <Form.Select value={role} onChange={(e) => setRole(e.target.value)} required>
            <option value="Admin">Admin</option>
            <option value="Content Editor">Content Editor</option>
          </Form.Select>
        </Form>
      </Modal.Body>
      <Modal.Footer className='border-0'>
        <Button onClick={handleSubmit} type="submit" disabled={isSubmitting}>
          {isSubmitting ? 'Adding...' : 'Add'}
        </Button>
        <Button onClick={onHide}>Cancel</Button>
      </Modal.Footer>
    </Modal>
  );
};



const AdminTab = () => {
  const [removePopUpShow, setRemovePopUpShow] = useState(false);
  const [suspendPopUpShow, setSuspendPopUpShow] = useState(false);
  const [selectedUserId, setSelectedUserId] = useState(null);
  const [adminData, setAdminData] = useState([]);
  const [modalShow, setModalShow] = useState(false);

  const fetchAdmins = async () => {
    try {
      const response = await fetch(`${config.API_BASE_URL}/get_admin_users.php`, { method: 'GET' });
      const data = await response.json();
      setAdminData(data);
    } catch (error) {
      // toast.error('Failed to fetch admin data');
    }
  };

  useEffect(() => {
    fetchAdmins(); // Fetch data on mount
  }, []);

  const handleAddMember = async (memberData) => {
    try {
      // Assuming there's an API to handle adding members with password
      const response = await fetch(`${config.API_BASE_URL}/add_member.php`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(memberData), // Send hashed password with other data
      });
      const data = await response.json();
  
      if (data.message) {
        setAdminData([...adminData, { ...memberData, id: adminData.length + 1 }]);
        toast.success('New member added successfully and invitation email sent!');
      } else {
        toast.error(data.error || 'Error adding new member');
      }
    } catch (error) {
      toast.error('Error adding new member');
    }
  };
  

  const handleSuspendUser = async (id) => {
    try {
      const response = await fetch(`${config.API_BASE_URL}/suspenduser.php`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: `id=${id}`,  // Send the user ID as part of the POST body
      });

      const data = await response.json();

      if (data.message) {
        toast.success('User suspended successfully!');
        setSuspendPopUpShow(false); // Close the popup
        setAdminData((prevAdminData) =>
          prevAdminData.map((user) =>
            user.id === id ? { ...user, status: 'Suspended' } : user
          )
        );
      } else {
        //toast.error(data.error || 'Failed to suspend user');
      }
    } catch (error) {
      //toast.error('Error suspending user');
    }
  };

  const handleRemoveUser = async (id) => {
    try {
      const response = await fetch(`${config.API_BASE_URL}/removeuser.php`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: `id=${id}`, // Send the user ID as part of the POST body
      });

      const data = await response.json();

      if (data.message) {
        toast.success('User removed successfully!');
        setRemovePopUpShow(false); // Close the popup
        setAdminData((prevAdminData) => prevAdminData.filter((user) => user.id !== id));
      } else {
        toast.error(data.error || 'Failed to remove user');
      }
    } catch (error) {
      toast.error('Error removing user');
    }
  };

  return (
    <div className="mb-5 container-fluid admin_usermanagement user_management py-0">
      <div className="d-flex export_data_config">
        <Button className="exportbutton new_rule" onClick={() => setModalShow(true)}>
          <p><i className="addicon bi bi-plus-circle"></i>Add New Member</p>
        </Button>
      </div>

      <div className="result_activity_log user_table_sec d-flex justify-content-between w-100">
        <div id="configtable" className="table-container top_space product_table">
          <table className="responsive-table">
            <thead>
              <tr>
                <th>S.No</th>
                <th>Name</th>
                <th>Email</th>
                <th>Role</th>
                <th>Status</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {adminData.length > 0 ? (
                adminData.map((data, index) => (
                  <tr key={data.id}>
                    <td>{index + 1}</td> {/* Serial number as index + 1 */}
                    <td>{data.name}</td>
                    <td>{data.email}</td>
                    <td>{data.role}</td>
                    <td>{data.status}</td>
                    <td>
                      <Popover 
                        content={
                          <div className='over_btns'>
                            {data.status !== 'Suspended' && (
                              <button onClick={() => { setSuspendPopUpShow(true); setSelectedUserId(data.id); }}>
                                Suspend
                              </button>
                            )}
                            <hr />
                            <button onClick={() => { setRemovePopUpShow(true); setSelectedUserId(data.id); }}>
                              Remove
                            </button>
                          </div>
                        } 
                        trigger="click" 
                        placement="right"
                      >
                        <div className='dot_over'>
                          <img src={three_dots} alt="options" />
                        </div>
                      </Popover>
                    </td>
                  </tr>
                ))
              ) : (
                <tr><td colSpan="6">No data available</td></tr>
              )}
            </tbody>

          </table>
        </div>
      </div>

      {/* Popups */}
      <SuspendPopUp
        show={suspendPopUpShow}
        onHide={() => setSuspendPopUpShow(false)}
        onConfirm={() => handleSuspendUser(selectedUserId)}
      />
      <RemovePopUp
        show={removePopUpShow}
        onHide={() => setRemovePopUpShow(false)}
        onConfirm={() => handleRemoveUser(selectedUserId)}
      />
      <MyVerticallyCenteredModal
        show={modalShow}
        onHide={() => setModalShow(false)}
        onAddMember={handleAddMember}
      />

      <ToastContainer />
    </div>
  );
};

export default AdminTab;
